import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=8281b100&scoped=true&"
import script from "./DetailsCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DetailsCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=8281b100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8281b100",
  null
  
)

export default component.exports